import { X } from "react-feather";
import { useMapStore } from "../../../store/mapStore";
import { useEffect } from "react";

const AirspaceZoneInfo = () => {
    const { setShowZoneInfoPopup, zoneInfo } = useMapStore((state) => state)
    return (
        <div className="bg-slate-100 z-[1000] p-4 right-28 rounded-xl top-4 w-fit h-fit absolute">
            <div className="flex justify-between">
                <div>
                    <h1 className="text-xl font-semibold capitalize">{zoneInfo.name}</h1>
                </div>
                <div>
                    <span className="cursor-pointer" onClick={() => setShowZoneInfoPopup(false)}><X /></span>
                </div>
            </div>
            <div className="mt-5">
                <div className="grid grid-cols-2">
                    <div className="p-2 rounded-xl bg-white mr-4 text-start">
                        <div className="font-semibold text-tblu">Zone Type</div>
                        <div className="capitalize text-lg">{zoneInfo.zoneCategory}</div>
                    </div>
                    <div className="p-2 rounded-xl bg-white mr-4 text-start">
                        <div className="font-semibold text-tblu">Radius</div>
                        <div className="capitalize text-lg break-all">{zoneInfo.radius}</div>
                    </div>
                </div>
                <div className="p-2 rounded-xl mt-5 bg-white mr-4 text-start">
                    <div className="font-semibold text-tblu">Position</div>
                    <div className="capitalize text-lg">{zoneInfo.position}</div>
                </div>
            </div>
        </div>
    )
};

export default AirspaceZoneInfo;